// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seasidetms_header_repair_link{display:none}.seasidetms_header_repair_link__icon{display:block;font-size:27px}@media only screen and (max-width:1024px){.seasidetms_header_repair_link{margin-top:44px;display:inline-block;float:right;margin-right:5px}}@media only screen and (max-width:768px){.seasidetms_header_repair_link{margin-top:23px}}@media only screen and (max-width:420px){.header_mid .seasidetms_header_repair_link{display:none}}", ""]);
// Exports
module.exports = exports;
